<template>
<div id="Trueorfalse" class="routes_components trueorfalse_view">
  <div class="row score_row">
    <div class="col text-right score_div">
      <span>Success <span class="score">{{success_count}}</span></span>
    </div>
    <div class="col text-center score_div">
      <span>Time <span class="score">{{timer}}</span></span>
    </div>
    <div class="col text-left score_div">
      <span>Failed <span class="score">{{failed_count}}</span></span>
    </div>
  </div>

  <div class="center_div_tof">
    <div class="tf_wrap">
      <div class="question_div">
        <div class="question_div_sub">
          {{question}}
        </div>
      </div>
      <div class="answer_div">
        <button type="button" name="button" class="true_btn" @click="true_clicked()" :class="btn_true" :disabled="disable_tof">True</button>
        <button type="button" name="button" class="false_btn" @click="false_clicked()" :class="btn_false" :disabled="disable_tof">False</button>
      </div>
    </div>
  </div>
  <div class="row options_row">
    <div class="col text-right p-0 m-0 tic_buttons_1">
      <div class="switch-field switch_one ">
        <input type="radio" id="radio-three" name="switch-two" v-model="mode" value="easy" :disabled="disable_mode" />
        <label for="radio-three">Easy</label>
        <input type="radio" id="radio-four" name="switch-two" v-model="mode" value="hard" :disabled="disable_mode" />
        <label for="radio-four">Hard</label>
      </div>
    </div>
    <div class="col text-center p-0 m-0 tic_buttons_3" v-if="current_btn == 'start'">
      <button type="button" class="reset_button " name="button" @click="start()">Start</button>
    </div>
    <div class="col text-center p-0 m-0 tic_buttons_3" v-if="current_btn == 'pause'">
      <button type="button" class="reset_button " name="button" @click="pause()">{{pause_text}}</button>
    </div>
    <div class="col text-center p-0 m-0 tic_buttons_3" v-if="current_btn == 'resume'">
      <button type="button" class="reset_button " name="button" @click="resume()">Resume</button>
    </div>
    <div class="col text-left p-0 m-0 tic_buttons_3">
      <button type="button" class="reset_button " name="button" @click="reset()" id="total_time_tof" v-b-popover.top="total_time">Reset</button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Trueorfalse',
  data() {
    return {
      pause_text: 'Pause',
      total_time: '',
      total_timer: 0,
      total_time_function: '',
      pause_tof: false,
      btn_true: '',
      btn_false: '',
      success_count: 0,
      failed_count: 0,
      timer_function: '',
      next_function: '',
      mode: 'easy',
      disable_mode: false,
      disable_tof: true,
      current_btn: 'start',
      question: '',
      answer: '',
      timer: 10,
      operator: ['+', '-'],
      answer_selection: ['true', 'false'],
      easy_questions_plus: [],
      easy_questions_minus: [],
      hard_questions_plus: [],
      hard_questions_minus: [],
    }
  },
  mounted() {
    this.$root.$emit('bv::disable::popover', 'total_time_tof');
  },
  beforeRouteLeave(to, from, next) {
    next();
    this.reset();
  },
  methods: {
    start() {
      this.current_btn = 'pause';
      if (this.mode == 'easy') {
        this.question_set_easy();
      } else if (this.mode == 'hard') {
        this.question_set_hard();
      }
      this.disable_mode = true;
      this.total_time_function = setInterval(function() {
        this.total_timer++;
        this.total_time = 'Total time : ' + this.total_timer.toString();
      }.bind(this), 1000);
    },
    pause() {
      this.pause_tof = true;
      this.pause_text = 'Pausing';
    },
    resume() {
      this.current_btn = 'pause';
      this.pause_tof = false;
      if (this.mode == "easy") {
        this.question_set_easy();
      } else if (this.mode == "hard") {
        this.question_set_hard();
      }
    },
    question_set_easy() {
      if (this.pause_tof != true) {
        this.disable_tof = false;
        this.timer_function = setInterval(function() {
          if (this.timer == 0) {
            this.nothing_clicked();
          } else {
            this.timer--;
          }
        }.bind(this), 1000);

        var ran_op = Math.floor(Math.random() * 2);
        var ran_ans = Math.floor(Math.random() * 2);
        var op = this.operator[ran_op];
        var ans = this.answer_selection[ran_ans];
        var digit_1;
        var digit_2;
        var correct_answer;
        var ran_wrong_ans;
        var wrong_ans;
        var check_array;
        if (op == '+') {
          digit_1 = Math.floor(Math.random() * 101);
          digit_2 = Math.floor(Math.random() * 101);
          check_array = digit_1 + ' + ' + digit_2;
          if (this.easy_questions_plus.includes(check_array) == true) {
            this.question_set_easy();
          } else {
            if (ans == 'true') {
              correct_answer = Number(digit_1) + Number(digit_2);
              this.question = digit_1 + ' + ' + digit_2 + ' = ' + correct_answer;
              this.answer = 'true';
              this.easy_questions_plus.push(digit_1 + ' + ' + digit_2);
            } else if (ans == 'false') {
              correct_answer = Number(digit_1) + Number(digit_2);
              ran_wrong_ans = Math.floor(Math.random() * 16);
              if (ran_wrong_ans > correct_answer) {
                wrong_ans = ran_wrong_ans + correct_answer;
                this.question = digit_1 + ' + ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.easy_questions_plus.push(digit_1 + ' + ' + digit_2);
              } else if (ran_wrong_ans < correct_answer) {
                wrong_ans = correct_answer - ran_wrong_ans;
                this.question = digit_1 + ' + ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.easy_questions_plus.push(digit_1 + ' + ' + digit_2);
              } else if (ran_wrong_ans == correct_answer) {
                wrong_ans = correct_answer + 8;
                this.question = digit_1 + ' + ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.easy_questions_plus.push(digit_1 + ' + ' + digit_2);
              }
            }
          }
        } else if (op == '-') {
          digit_1 = Math.floor(Math.random() * 101);
          digit_2 = Math.floor(Math.random() * 101);
          check_array = digit_1 + ' - ' + digit_2;
          if (this.easy_questions_minus.includes(check_array) == true) {
            this.question_set_hard();
          } else {
            if (digit_1 > digit_2) {
              correct_answer = Number(digit_1) - Number(digit_2);
            } else {
              correct_answer = Number(digit_2) - Number(digit_1);
            }
            if (ans == 'true') {
              if (digit_1 > digit_2) {
                this.question = digit_1 + ' - ' + digit_2 + ' = ' + correct_answer;
                this.easy_questions_minus.push(digit_1 + ' - ' + digit_2);
              } else {
                this.question = digit_2 + ' - ' + digit_1 + ' = ' + correct_answer;
                this.easy_questions_minus.push(digit_2 + ' - ' + digit_1);
              }
              this.answer = 'true';
            } else if (ans == 'false') {
              ran_wrong_ans = Math.floor(Math.random() * 16);
              if (ran_wrong_ans > correct_answer) {
                wrong_ans = ran_wrong_ans + correct_answer;
                this.question = digit_1 + ' - ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.easy_questions_minus.push(digit_1 + ' - ' + digit_2);
              } else if (ran_wrong_ans < correct_answer) {
                wrong_ans = correct_answer - ran_wrong_ans;
                this.question = digit_1 + ' - ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.easy_questions_minus.push(digit_1 + ' - ' + digit_2);
              } else if (ran_wrong_ans == correct_answer) {
                wrong_ans = correct_answer + 6;
                this.question = digit_1 + ' - ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.easy_questions_minus.push(digit_1 + ' - ' + digit_2);
              }
            }
          }
        }
      } else {
        this.question = 'Paused';
        this.current_btn = 'resume';
        this.pause_text = 'Pause';
        this.disable_tof = true;
        this.answer = '';
      }
    },
    question_set_hard() {
      if (this.pause_tof != true) {
        this.disable_tof = false;
        this.timer_function = setInterval(function() {
          if (this.timer == 0) {
            this.nothing_clicked();
          } else {
            this.timer--;
          }
        }.bind(this), 1000);

        var ran_op = Math.floor(Math.random() * 2);
        var ran_ans = Math.floor(Math.random() * 2);
        var op = this.operator[ran_op];
        var ans = this.answer_selection[ran_ans];
        var digit_1;
        var digit_2;
        var correct_answer;
        var ran_wrong_ans;
        var wrong_ans;
        var check_array;
        if (op == '+') {
          digit_1 = (Math.floor(Math.random() * 901)+100);
          digit_2 = (Math.floor(Math.random() * 901)+100);
          check_array = digit_1 + ' + ' + digit_2;
          if (this.hard_questions_plus.includes(check_array) == true) {
            this.question_set_easy();
          } else {
            if (ans == 'true') {
              correct_answer = Number(digit_1) + Number(digit_2);
              this.question = digit_1 + ' + ' + digit_2 + ' = ' + correct_answer;
              this.answer = 'true';
              this.hard_questions_plus.push(digit_1 + ' + ' + digit_2);
            } else if (ans == 'false') {
              correct_answer = Number(digit_1) + Number(digit_2);
              ran_wrong_ans = Math.floor(Math.random() * 41);
              if (ran_wrong_ans > correct_answer) {
                wrong_ans = ran_wrong_ans + correct_answer;
                this.question = digit_1 + ' + ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.hard_questions_plus.push(digit_1 + ' + ' + digit_2);
              } else if (ran_wrong_ans < correct_answer) {
                wrong_ans = correct_answer - ran_wrong_ans;
                this.question = digit_1 + ' + ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.hard_questions_plus.push(digit_1 + ' + ' + digit_2);
              } else if (ran_wrong_ans == correct_answer) {
                wrong_ans = correct_answer + 15;
                this.question = digit_1 + ' + ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.hard_questions_plus.push(digit_1 + ' + ' + digit_2);
              }
            }
          }
        } else if (op == '-') {
          digit_1 = (Math.floor(Math.random() * 901)+100);
          digit_2 = (Math.floor(Math.random() * 901)+100);
          check_array = digit_1 + ' - ' + digit_2;
          if (this.hard_questions_minus.includes(check_array) == true) {
            this.question_set_hard();
          } else {
            if (digit_1 > digit_2) {
              correct_answer = Number(digit_1) - Number(digit_2);
            } else {
              correct_answer = Number(digit_2) - Number(digit_1);
            }
            if (ans == 'true') {
              if (digit_1 > digit_2) {
                this.question = digit_1 + ' - ' + digit_2 + ' = ' + correct_answer;
                this.hard_questions_minus.push(digit_1 + ' - ' + digit_2);
              } else {
                this.question = digit_2 + ' - ' + digit_1 + ' = ' + correct_answer;
                this.hard_questions_minus.push(digit_2 + ' - ' + digit_1);
              }
              this.answer = 'true';
            } else if (ans == 'false') {
              ran_wrong_ans = Math.floor(Math.random() * 41);
              if (ran_wrong_ans > correct_answer) {
                wrong_ans = ran_wrong_ans + correct_answer;
                this.question = digit_1 + ' - ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.hard_questions_minus.push(digit_1 + ' - ' + digit_2);
              } else if (ran_wrong_ans < correct_answer) {
                wrong_ans = correct_answer - ran_wrong_ans;
                this.question = digit_1 + ' - ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.hard_questions_minus.push(digit_1 + ' - ' + digit_2);
              } else if (ran_wrong_ans == correct_answer) {
                wrong_ans = correct_answer + 15;
                this.question = digit_1 + ' - ' + digit_2 + ' = ' + wrong_ans;
                this.answer = 'false';
                this.hard_questions_minus.push(digit_1 + ' - ' + digit_2);
              }
            }
          }
        }
      } else {
        this.question = 'Paused';
        this.current_btn = 'resume';
        this.pause_text = 'Pause';
        this.disable_tof = true;
        this.answer = '';
      }
    },
    true_clicked() {
      this.disable_tof = true;
      clearInterval(this.timer_function);
      if (this.answer == 'true') {
        this.btn_true = 'success_btn';
        this.success_count++;
      } else {
        this.btn_true = 'failed_btn';
        this.failed_count++;
      }

      this.next_function = setTimeout(function() {
        this.btn_true = '';
        this.timer = 10;
        if (this.mode == "easy") {
          this.question_set_easy();
        } else if (this.mode == "hard") {
          this.question_set_hard();
        }
      }.bind(this), 2500);
    },
    false_clicked() {
      this.disable_tof = true;
      clearInterval(this.timer_function);
      if (this.answer == 'false') {
        this.btn_false = 'success_btn';
        this.success_count++;
      } else {
        this.btn_false = 'failed_btn';
        this.failed_count++;
      }
      this.next_function = setTimeout(function() {
        this.btn_false = '';
        this.timer = 10;
        if (this.mode == "easy") {
          this.question_set_easy();
        } else if (this.mode == "hard") {
          this.question_set_hard();
        }
      }.bind(this), 2500);
    },
    nothing_clicked() {
      this.failed_count++;
      clearInterval(this.timer_function);

      this.btn_true = 'no_click';
      this.btn_false = 'no_click';

    this.next_function = setTimeout(function() {
        this.btn_true = '';
        this.btn_false = '';
        this.timer = 10;
        if (this.mode == "easy") {
          this.question_set_easy();
        } else if (this.mode == "hard") {
          this.question_set_hard();
        }
      }.bind(this), 2500);
    },
    reset() {
      clearTimeout(this.next_function);
      clearInterval(this.timer_function);
      clearInterval(this.total_time_function);
      this.disable_tof = true;
      this.total_time = '';
      this.pause_text = 'Pause';
      this.total_time_function = '';
      this.pause_tof = false;
      this.btn_true = '';
      this.btn_false = '';
      this.success_count = 0;
      this.failed_count = 0;
      this.disable_mode = false;
      this.disable_tof = true;
      this.current_btn = 'start';
      this.question = '';
      this.answer = '';
      this.timer = 10;
      this.operator = ['+', '-'];
      this.answer_selection = ['true', 'false'];
      this.easy_questions_plus = [];
      this.easy_questions_minus = [];
      this.hard_questions_plus = [];
      this.hard_questions_minus = [];
    }
  }
}
</script>

<style>

</style>
